import ActionButton from 'components/ActionButton';
import { Loading } from 'components/loading/Loading';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { fetchInventoryItemsForInventorySpotChecks } from 'services';
import { formatInventoryItemAddressWith0, showError, sortArray, stringifyAndParseObj } from 'utils';
import styles from './index.module.scss';
import InventoryItem from './inventoryItem';

const InventorySpotCheck = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [spotCheckData, setSpotCheckData] = useState({}) as any;

  const fetchInventoryItemsForInventorySpotChecksFn = async () => {
    try {
      setLoading(true);
      let response = await fetchInventoryItemsForInventorySpotChecks({ limit: 300 });
      response = stringifyAndParseObj(response);
      const inventoryItemsWithFormattedAddress = response?.inventoryItems?.map((item)=>{
        const inventoryStartAddressString = _.get(item, 'inventoryAddress.start.addressString');
        return {
          ...item,
          inventoryStartAddress: formatInventoryItemAddressWith0(inventoryStartAddressString) || '',
        };
      });
      const sortedInventoryItemsBasedOnInventoryAddress = sortArray(inventoryItemsWithFormattedAddress, 'inventoryStartAddress');
      const first100Items = sortedInventoryItemsBasedOnInventoryAddress?.slice(0, 100);
      setSpotCheckData({ ...response, inventoryItems: first100Items });
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInventoryItemsForInventorySpotChecksFn();
  }, []);

  if (loading) return <Loading />;

  const getHeader = () => (
    <div className={styles['header']}>
      <div className={styles['heading']}>Inventory items for inventory spot check</div>
    </div>
  );

  const inventoryItem = (inventoryItem: any, index) => {
    return <InventoryItem key={`${index}`} inventoryItem={inventoryItem} />;
  };

  return (
    <>
      {getHeader()}
      <div className={styles['spot-check-items-count']}>Total items for spot check: {spotCheckData?.total}</div>
      <div id={'main-container'} className={`${styles['main-container']}`}>
        <div className={`container-fluid ${styles['inventory-items']}`}>
          {spotCheckData?.inventoryItems?.map(inventoryItem)}
        </div>
        <div style={{ alignSelf: 'center' }}>
          <ActionButton
            text="Refresh" 
            onClick={fetchInventoryItemsForInventorySpotChecksFn} 
            isLoading={loading} 
            active={!loading} 
            customClass="my-3 align-self-center" 
          />
        </div>
      </div>
    </>
  );
};

export default InventorySpotCheck;
